import { useState, useRef, useEffect } from 'react';
import HttpService from '../config/http/http.service';
import { endpoints } from '../constants/endpoints';
import { AxiosRequestConfig } from 'axios';

const usePegaMas = () => {
    const httpService = new HttpService();
    const [succeed, setSucceed] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const [data, setData] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(false);
    const abortControllerRef = useRef<AbortController | null>(null);

    useEffect(() => {
        return () => abortControllerRef.current?.abort();
    }, []);

    const createAbortController = () => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        abortControllerRef.current = new AbortController();
    };

    const getPrizes = async (gameCode: string) => {
        createAbortController();

        try {
            const token = localStorage.getItem('authToken');

            const options: AxiosRequestConfig = {
                headers: { token: `Bearer ${token}` },
                params: { gameCode },
                signal: abortControllerRef?.current?.signal
            };

            const data = await httpService.get(endpoints.GET_PRIZES, options);

            if (!data) return;

            setSucceed(true);
            const { mainObject }: any = data;
            const positions = mainObject[0].multipliers.map((item: any) => item.position);
            setData(positions);
        
        } catch (error: any) {
            if (error.name === 'AbortError') {
                console.warn('Petición cancelada:', error);
                return;
            }
            setError(true);
            setSucceed(false);
        }
    };

    const getResults = async (gameCode: string, resultPerPage: number) => {
        createAbortController();

        try {
            const token = localStorage.getItem('authToken');

            const options: AxiosRequestConfig = {
                headers: { token: `Bearer ${token}` },
                params: { gameCode, resultPerPage },
                signal: abortControllerRef?.current?.signal
            };

            const data = await httpService.get(endpoints.GET_RESULTS, options);

            if (!data) return;

            setSucceed(true);
            const { mainObject }: any = data;
            setData(mainObject);
        
        } catch (error: any) {
            if (error.name === 'AbortError') {
                console.warn('Petición cancelada:', error);
                return;
            }
            setError(true);
            setSucceed(false);
        }
    };

    const getExternalLotteryResults = async (cid: string) => {
        createAbortController();

        try {
            const token = localStorage.getItem('authToken');

            const options: AxiosRequestConfig = {
                headers: { token: `Bearer ${token}` },
                params: { cid },
                signal: abortControllerRef?.current?.signal
            };

            const data = await httpService.get(endpoints.EXTERNALLOTTERIES_GET_RESULTS, options);

            if (!data) return;

            setSucceed(true);
            const { mainObject }: any = data;
            setData(mainObject);
        
        } catch (error: any) {
            if (error.name === 'AbortError') {
                console.warn('Petición cancelada:', error);
                return;
            }
            setError(true);
            setSucceed(false);
        }
    }; 

    const getEmbudoResults = async (resultPerPage: number) => {
        createAbortController();
        setLoading(true);

        try {
            const token = localStorage.getItem('authToken');

            const data = await httpService.post(endpoints.EMBUDO_GET_RESULTS, {
                token,
                ResultPerPage: resultPerPage
            }, { signal: abortControllerRef?.current?.signal });

            if (!data) return;

            setLoading(false);
            setSucceed(true);
            const { mainObject }: any = data;
            setData(mainObject);
            return mainObject;
        
        } catch (error: any) {
            if (error.name === 'AbortError') {
                console.warn('Petición cancelada:', error);
                return;
            }
            setError(true);
            setSucceed(false);
            setLoading(false);
        }
    };

    return {
        getPrizes,
        getResults,
        getExternalLotteryResults,
        getEmbudoResults,
        data,
        loading,
        succeed
    };
};

export default usePegaMas;